import { render, staticRenderFns } from "./Simple.vue?vue&type=template&id=6e1e5121&scoped=true&"
var script = {}
import style0 from "./Simple.vue?vue&type=style&index=0&id=6e1e5121&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e1e5121",
  null
  
)

export default component.exports